import axios from 'axios'

const { REACT_APP_API_URL } = process.env
const token = JSON.parse(localStorage.getItem('auth-token'));


export function WakeUpService() {
        return fetch(`${REACT_APP_API_URL}/auth/wakeup`, {
                method: "GET",
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                }
        }).then((result) => {
                return result;
        }).catch(error => console.log(error));
}

export function SignUpService(body) {
        return fetch(`${REACT_APP_API_URL}/auth/signup`, {
                method: 'POST',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
        }).then((result) => {
                return result;
        }).catch(error => console.log(error));
}

export function SignInService(body) {
        return fetch(`${REACT_APP_API_URL}/auth/signin`, {
                method: 'POST',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
        }).then((result) => {
                return result;
        }).catch(error => console.log(error));
}

export function FetchAllProjectsService() {
        return fetch(`${REACT_APP_API_URL}/dashboard/workspace_projects`, {
                method: 'GET',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                }
        }).then((result) => {
                return result;
        }).catch(error => console.log(error));
}

export function SendVerificationEmailService() {
        return fetch(`${REACT_APP_API_URL}/auth/send_email_for_verification`, {
                method: 'GET',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                }
        }).then((result) => {
                return result;
        }).catch(error => console.log(error));
}

export function VerifyEmailTokenService(body) {
        return fetch(`${REACT_APP_API_URL}/auth/verify_email`, {
                method: 'POST',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                },
                body: JSON.stringify(body)
        }).then((result) => {
                return result;
        }).catch(error => console.log(error));
}

export function ProjectCreationService(body) {
        return axios({
                method: 'post',
                url: `${REACT_APP_API_URL}/dashboard/project_creation`,
                headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${token}`
                },
                data: body
        }).then((result) => { 
                return result;
        }, (error) => {
                if(error.status === 406){
                        console.log(error.message)
                }
        });
}

export function FetchSingleProjectService(body){
        return fetch(`${REACT_APP_API_URL}/dashboard/single_project`, {
                method: 'POST',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(body)
        }).then((result) => {
                return result;
        }).catch(error => console.log(error));
}
export function PreprocessDatasetService(body){
        return fetch(`${REACT_APP_API_URL}/dashboard/preprocess_dataset`, {
                method: 'POST',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(body)
        }).then((result) => {
                return result;
        }).catch(error => console.log(error));
}

export function DatasetProcessingDetailsService(body) {
        return fetch(`${REACT_APP_API_URL}/dashboard/dataset_processing_details`, {
                method: 'POST',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(body)
        }).then((result) => {
                return result;
        }).catch(error => console.log(error));
}

export function WakeUpHeavyScriptsService(){
        var url= "https://analyzeit-heavy-scripts.herokuapp.com"
        fetch(`${url}/wakeup`, {
                method: 'GET',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                },
        }).then((result) => {
        }).catch(error => console.log(error));
}


export function ProjectDeletionService() {

}
export function UploadDatasetService() {

}
export function DeleteDatasetService() {

}















